<script>
import axios from 'axios';
import { mapGetters, mapState } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';
import RbxConfirmDialog from '../../../shared/reybex/RbxConfirmDialog';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'UserBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
    RbxConfirmDialog,
  },
  mixins: [fieldVisibilityMixin, snackbarMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'user',
      isConfirmDialogDisplayed: false,
      roleOptions: [
        { id: 0, text: 'Normaler Benutzer' },
        { id: 1, text: 'Verfahren-Verantwortlicher' },
        { id: 2, text: 'Admin' },
      ],
    };
  },
  computed: {
    ...mapState('App', ['hasDeleteRights']),
    confirmMessage() {
      return `Möchten Sie das Passwort zurücksetzen
      und die neuen Benutzerdaten an die Email-Adresse ${this.user.email} verschicken?`;
    },
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onConfirm() {
      axios
        .post('/resetPassword', { id: this.user.id })
        .then(() => {
          this.showSuccessMessage('Das Passwort wurde zurückgesetzt und per Email versendet.');
          this.isConfirmDialogDisplayed = false;
        })
        .catch((err) => {
          console.log(err);

          this.showErrorMessage(err || 'Das Password konnte nicht zurückgesetzt werden.');
        });
    },
    showConfirmDialog() {
      if (this.user.email) {
        this.isConfirmDialogDisplayed = true;
      } else {
        this.showErrorMessage('Bitte tragen Sie eine Email-Adresse für den Benutzer ein, damit das neue Passwort versendet werden kann.');
      }
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
  },
};
</script>

<template>
  <v-layout row wrap>
    <!-- Basic information left column -->
    <v-flex md8 xs12>
      <h4 class="user-detail-tab-title">Stammdaten</h4>
      <v-layout row wrap>
        <v-flex v-if="isFieldVisible('user.salutation')" md4 py-0>
          <rbx-remote-combobox
            v-model="user.salutation"
            label="Anrede"
            :selected="user.salutation"
            domain="salutation"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('user.firstname')" md4 py-0>
          <v-text-field v-model="user.firstname" label="Vorname" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.surname')" md4 py-0>
          <v-text-field v-model="user.surname" label="Nachname" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.phone')" md4 py-0>
          <v-text-field v-model="user.phone" label="Telefon" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.mobile')" md4 py-0>
          <v-text-field v-model="user.mobile" label="Handy" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.fax')" md4 py-0>
          <v-text-field v-model="user.fax" label="Fax" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.street')" md4 py-0>
          <v-text-field v-model="user.street" label="Straße" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.zipcode')" md4 py-0>
          <v-text-field v-model="user.zipcode" label="PLZ" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.city')" md4 py-0>
          <v-text-field v-model="user.city" label="Stadt" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.email')" md4 py-0>
          <v-text-field v-model="user.email" label="E-Mail-Adresse" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.department')" md4 py-0>
          <rbx-remote-combobox
            v-model="user.department"
            label="Abteilung"
            :selected="user.department"
            domain="department"
          />
        </v-flex>

        <v-flex v-if="auth.hasDeleteRights" xs12 md4 py-0>
          <v-select
            height="22"
            :items="roleOptions"
            v-model="user.roleStatus"
            item-value="id"
            item-text="text"
            label="Rolle"
          />
        </v-flex>

        <v-flex xs12 md12 v-if="isFieldVisible('user.comment')">
          <rbx-text-editor label="Notiz" v-model="user.comment"/>
        </v-flex>
      </v-layout>

      <h4 class="user-detail-tab-title">Administration</h4>
      <v-layout row wrap>
        <v-flex v-if="isFieldVisible('user.username')" md4 py-0>
          <v-text-field v-model="user.username" label="Benutzername" height="22" class="caption"/>
        </v-flex>

        <v-flex v-if="isFieldVisible('user.password')" md4 py-0>
          <v-text-field
            v-model="user.password"
            label="Neues Passwort"
            height="22"
            class="caption"
            type="password"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('user.password')" md4 py-0>
          <v-btn slot="activator" @click="showConfirmDialog()" color="info" fab flat>
            <v-icon>email</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md2 py-0>
          <v-switch
            v-model="user.isDelete"
            label="Gelöscht"
            height="0"
            :readonly="!auth.hasDeleteRights"
          />
        </v-flex>

        <v-flex md2 py-0>
          <v-switch v-model="user.enabled" label="Aktiviert" height="0"/>
        </v-flex>
      </v-layout>
    </v-flex>

    <rbx-confirm-dialog
      @confirm="onConfirm()"
      @refuse="onRefuse()"
      :message="confirmMessage"
      :is-displayed="isConfirmDialogDisplayed"
    />
  </v-layout>
</template>
